import {NgModule} from '@angular/core';
import {LoginComponent} from './components/login/login.component';
import {SharedModule} from '../shared/shared.module';
import {SidenavComponent} from './components/sidenav/sidenav.component';
import {ToolbarComponent} from './components/toolbar/toolbar.component';
import {LinkViewComponent} from './components/sidenav/link-view/link-view.component';
import {NbAccordionModule} from '@nebular/theme';

@NgModule({
    declarations: [
        LoginComponent,
        SidenavComponent,
        ToolbarComponent,
        LinkViewComponent
    ],
    imports: [
        SharedModule,
        NbAccordionModule
    ],
    exports: [
        LoginComponent,
        SidenavComponent,
        ToolbarComponent
    ]
})
export class CoreModule {
}
